import React from 'react';
import UpdateProductMutation from '@admin/graphql-api/_old_mutations/_UpdateProduct';
import ProductQuery from '@admin/graphql-api/_old_queries/ProductQuery';
import {graphql} from '@apollo/client/react/hoc';
import {Redirect} from 'react-router-dom';
import {ImageUploader} from '@core/components/Uploader';
import Loading from '@core/ui/Loading';

class ProductImage extends React.Component {
  state = {
    loading: false,
    complete: false,
  };

  onChange = (action, media) => {
    const {
      updateProduct,
      product: {id, name, slug},
    } = this.props;

    if (action == 'added') {
      this.setState({loading: true});
    }

    if (action == 'uploaded') {
      updateProduct({
        id,
        name,
        slug,
        imageId: media.object.id,
      }).then((resp) => {
        this.setState({loading: false, complete: 'true'});
      });
    }
  };

  render() {
    const {company, product} = this.props;
    const {loading, complete} = this.state;

    if (complete) {
      return (
        <Redirect to={`/companies/${company.id}/products/${product.id}`} />
      );
    }

    return (
      <div>
        {loading && <Loading absolute />}
        <ImageUploader onChange={this.onChange} />
      </div>
    );
  }
}

export default graphql(UpdateProductMutation, {
  props: ({mutate}) => ({
    updateProduct: (input) => {
      return mutate({
        variables: {
          input,
        },
        update: (
          store,
          {
            data: {
              updateProduct: {
                product: {id, image},
              },
            },
          }
        ) => {
          // Stuff the new journey into the cache.
          const query = {
            query: ProductQuery,
            variables: {
              id,
            },
          };

          query.data = store.readQuery(query);

          query.data.admin.product.image = Object.assign(
            {},
            query.data.admin.product.image,
            image
          );

          store.writeQuery(query);
        },
      });
    },
  }),
})(ProductImage);
